<template>
<!--  <div id="app" :style="{width: $common.screenWidth > $common.screenHeight ? '750px' : $common.screenWidth + 'px', marginLeft: ($common.screenWidth-750)/2 + 'px'}">-->
  <div id="app">
    <div v-if="positionId">
      <Wp_group_member_app
          :position_id="positionId"
          :keyword="keyword"
      ></Wp_group_member_app>
    </div>
    <div v-else>
      <Wp_group_owner_app></Wp_group_owner_app>
    </div>

    <!--        <van-button id="to_top_button" type="primary" plain round icon="upgrade" size="larger"-->
    <!--                    style="padding-right:20px;display: none;position:fixed;right:0;bottom:0; margin-bottom: 70px; margin-right: -20px; background-color: #ffffff99"-->
    <!--                    v-on:click="toTop"-->
    <!--        >-->
    <!--        </van-button>-->

    <van-icon
        id="to_top_button"
        size="40px"
        name="upgrade"
        @click="toTop"
        style="
        display: none;
        position: fixed;
        right: 30px;
        bottom: 0;
        margin-bottom: 70px;
        margin-right: -20px;
        background-color: rgba(255, 255, 255, 0.3);
        z-index: 10;
        border-radius: 20px;
      "
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { Button } from 'iview'
import Wp_group_owner_app from './components/pages/Wp_group_owner_app'
import Wp_group_member_app from './components/pages_user/Wp_group_member_app'

Vue.component('i-button', Button)

export default {
  name: 'app',
  components: { Wp_group_member_app, Wp_group_owner_app },
  data () {
    return {
      showGroupOwner: false,
      positionId: '',
      keyword: '',
      test: '',
    }
  },

  created () {
    // this.$capUtils.splashScreenHide();
    this.positionId = this.$getUrlParamValue('pid')
    this.keyword = this.$getUrlParamValue('keyword')

    this.test = this.$getUrlParamValue('test')
    this.$store.commit('test', this.test)

    this.getPayConfig()

    // this.$capUtils.getID((res) => {
    //   console.log(res);
    // });
    // this.$capUtils.getDeviceInfo((res) => {
    //   console.log(res);
    // });
  },
  beforeDestroy () {},
  mounted () {
    // this.getGoodsDataNoParams();
    //添加滚动条的监听，用于判断显示"返回顶部"按钮
    window.addEventListener('scroll', this.scrollListener)
  },

  destroyed () {
    window.removeEventListener('scroll', this.scrollListener)
  },
  methods: {

    getPayConfig () {
      this.$getSubConfig(response => {

        if (response && response.code === 200) {
          let pay_start_day = response.data[0].s_u_beginday
          let pay_end_day = response.data[0].s_u_endday
          this.$store.commit('setPayStartDay', Number(pay_start_day))
          this.$store.commit('setPayEndDay', Number(pay_end_day))
        }
      })
    },

    isTest () {
      let url = window.location.href
      if (url.indexOf('localhost:') !== -1 || url.indexOf('192.168.') !== -1) {
        return true
      } else {
        return false
      }
    },

    /**
     * 监听滚动条，判断显示"返回顶部"按钮
     */
    scrollListener () {
      let topBtn = document.getElementById('to_top_button')
      //滚动条距离顶部距离
      let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
      //窗口固定高度
      let browserHeight = window.outerHeight
      if (scrollTop > browserHeight) {
        topBtn.style.display = 'block'
      } else {
        topBtn.style.display = 'none'
      }
    },

    /**
     * 返回顶部
     */
    toTop () {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
  },
}
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif, verdana, tahoma, "Avenir";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/

  /* //  为您的应用头部 */
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  /* // 为您的应用尾部 */
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color:#EEEEEE;
}


.listStyle {
  background-color: #eeeeee;
  padding-top: 1px;
}

.skuCardStyle {
  background-color: white;
  padding: 5px;
  border-radius: 6px;
}

</style>
